/**
 * Centralized toast module — drop-in replacement for `import { toast } from "sonner"`.
 * All pages should import from here instead of sonner directly.
 * This re-exports a toast object whose .success/.error/.info/.warning methods
 * are wired to the custom AorraToast modal system.
 */
import { aorraToast } from "../components/AorraToast";

export const toast = {
  success: (msg, opts) => aorraToast.success(msg, opts),
  error:   (msg, opts) => aorraToast.error(msg, opts),
  info:    (msg, opts) => aorraToast.success(msg, opts),
  warning: (msg, opts) => aorraToast.error(msg, opts),
  // fallback for any plain toast("message") calls
  __call:  (msg, opts) => aorraToast.success(msg, opts),
};

export default toast;
